<template>
    <router-link class="list-group-item list-group-item-action"
                 v-bind:to="`/tasks/list/${ task._id }`">
        <div class="d-flex justify-content-between align-items-center w-100">
            <div class="flex-grow-1 pr-2 pr-lg-0">
                <div class="mb-1">
                    <small>
                        {{ createdAt }}
                    </small>
                </div>
                <h5 class="font-noto-serif-tc font-weight-bolder mb-1">
                    {{ title }}
                </h5>
                <p class="mb-0">
                    {{ address }}
                </p>
            </div>
            <div>
                <div class="account-tag text-decoration-none d-inline-flex align-items-center rounded-pill border shadow-sm pl-1">
                    <div class="font-weight-bolder text-nowrap text-dark mx-2">
                        {{ owner.name }}
                    </div>
                    <b-avatar class="border-0"
                              v-bind:src="avatar">
                    </b-avatar>
                </div>
            </div>

        </div>

    </router-link>
</template>

<script>
import format from "date-fns/format";
import { zhTW } from "date-fns/locale";
import { DefaultMapCenter } from "../../../config";

import { BAvatar, } from "bootstrap-vue";

export default {
    name: "ListItem",
    components: {
        BAvatar,
    },
    props: {
        task: {
            type: Object,
        },
    },
    data () {
        return {

        };
    },
    computed: {
        title () {
            return this.task?.title ?? "";
        },
        site () {
            return this.task?.site ?? { "coordinate": DefaultMapCenter }
        },
        address () {
            return this.site?.address ?? "";
        },
        service () {
            return this.task?.service ?? null;
        },
        serviceName () {
            return this.service?.name ?? "";
        },
        servicePhoto () {
            if (this.service) {
                return this.service.photo[0];
            }
            return "";
        },
        skuSelected () {
            if (
                this.service &&
                this.task.sku
            ) {
                const target = this.service.sku
                    .find(
                        ({ _id }) => _id === this.task.sku
                    );
                if (target) {
                    return target;
                }
                return null;
            }
            return null;
        },
        createdAt () {
            return format(
                new Date(this.task.createdAt),
                "PPPp",
                {
                    "locale": zhTW,
                }
            );
        },
        owner () {
            return this.task?.owner ?? null
        },
        avatar () {
            return this.owner ?
                `${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ this.owner.avatar }` :
                "";
        },
    },
    methods: {},
}
</script>

<style lang="scss" scoped>

</style>
